export default "__VITE_ASSET__BpUI89Ka__"